// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3d14d8c1","732":"00bcb2a0","977":"f9cdbb55"}[chunkId] + ".chunk.js";
};